/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
/**
 * @ignore - internal component.
 */ const Tablelvl2Context = /*#__PURE__*/ React.createContext();
if ("production" !== 'production') {
    Tablelvl2Context.displayName = 'Tablelvl2Context';
}
var _default = exports.default = Tablelvl2Context;
